import React from "react";
import {Card, CardHeader, CardBody, CardFooter, Divider, Link, Image} from "@nextui-org/react";
const HomePageCard = ({Logo, textBody, title, classNames}) =>{
  return (
    <Card className={`max-w-[400px] ${classNames ? classNames: ""}`}>
      <CardHeader className="flex-col gap-3">
		  <div>
			 <Logo/>
		  </div>
        <div className="flex flex-col">
          <p className="text-md  text-[1.3rem] uppercase text-center">{title}</p>
        </div>
      </CardHeader>
      <CardBody>
		  <div>
			 <p className = "indent-3 p-[0.2rem] text-gray-900">{textBody}</p>
		  </div>
      </CardBody>
    </Card>
  );
}
export default HomePageCard; 

